import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { PublicCompanyLeadsFunnelContractProductCategoryValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { transformNewContractProductCategory } from '@/features/publicCompanyLeadsFunnel/services/publicCompanyLeadProductCategoryTransformers'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { ContractProductCategoryData, PublicCompanyLeadData } from '../types/publicCompanyLead'

interface UseUpdatePublicCompanyLeadContractProduct {
  publicCompanyLead?: PublicCompanyLeadData
  contractProductCategory: ContractProductCategoryData
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useUpdatePublicCompanyLeadContractProduct = ({
  publicCompanyLead,
  contractProductCategory,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadContractProduct) => {
  const publicAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updatePublicCompanyLeadContractProduct'],
    mutationFn: async (data: PublicCompanyLeadsFunnelContractProductCategoryValidationSchema) => {
      const contract = {
        contract_product_categories_attributes: [
          {
            id: contractProductCategory.id,
            ...transformNewContractProductCategory(
              data,
              publicCompanyLead?.contract?.contract_product_categories || [],
            ),
            // contract_product_category_products_attributes: [
            //   ...getRailsUpdate(
            //     contractProductCategory?.contract_product_category_products || [],
            //     data?.contract_product_category_products || [],
            //     (x) => x.product?.id,
            //     (y) => y.id || '',
            //     mapToDeletion,
            //     () =>
            //       transformNewContractProductCategory(
            //         data,
            //         publicCompanyLead?.contract?.contract_product_categories || [],
            //       ),
            //   ),
            // ],
          },
        ],
      }

      return await publicAxios.put(`/funnel/public/leads/${publicCompanyLead?.id}/update_contract_products`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
